<template>
	<div id="app" :class="[
		{ 'car_bg' : carBackCheck },
		{ 'bottom_menu' : menuShowCheck },
		{ 'stop-scrolling' : (!onload || routeLoading) }
	]">
		<vue-progress-bar></vue-progress-bar>

		<Header/>
		
		<!-- <transition :name="transitionName" mode="out-in">
			<router-view class="content-wrap" :key="$route.path"></router-view>
		</transition> -->
		<router-view class="content-wrap" :key="$route.path"></router-view>
		
		<Footer/>

		<Modal/>
	
		<!-- <SpinnerOnload type="absolute" :loading="(!onload || routeLoading)"/> -->

		<Spinner type="absolute" :loading="loading" v-if="!(!onload || routeLoading)"/>

	</div>
</template>

<script>
import { mapState } from 'vuex';
import Header from './components/core/Header.vue';
import Footer from './components/core/Footer.vue';
import Modal from './components/modal/ModalBase.vue';
import Spinner from './components/core/Spinner.vue';
// import LoadingBar from './components/core/LoadingBar.vue';
// import SpinnerOnload from './components/core/SpinnerOnload.vue';

export default {
	name: 'App',

	components: {
		Header,
		Footer,
		Modal,
		Spinner,
		// LoadingBar,
		// SpinnerOnload
	},
	data() {
		return {
		}
	},
	watch: {
	},
	created() {
		//nextTick html mounted 이후 실행
		//child component 존재시 해당 child 마운트 완료후 parent 마운트 완료
		this.$nextTick(() => {
			setTimeout(this.setJavascript, 1000);
		})
	},
	computed: {
		...mapState({
			onload: state => state.common.onload,
			loading: state => state.common.loading,
			routeLoading: state => state.common.routeLoading,
			transitionName: state => state.common.transitionName,
		}),

		carBackCheck() {
			return [
				'Login',
				'JoinName',
				'JoinNiceAuth',
				'JoinPassword',
				'JoinTerms',
				'JoinSocial',
				'JoinComplete',
				'PwNiceAuth',
				'PwChange',
				'PhonePwChk',
				'PhoneNiceAuth',
				'PhoneComplete',
			].includes(this.$route.name);
		},
		menuShowCheck() {
			return [
				'Main',
				/*'Menu',*/
				'MyBookingList',
			].includes(this.$route.name);
		}
	},
	mounted() {
		// this.$nextTick(function() {});
	},
	methods: {

		setJavascript() {
			// let js = [
			// 	// 'js/owl.carousel.js',
			// 	// 'js/semantic.js',
			// 	// 'js/main.js',
			// 	// 'js/developer.js',
			// ];
			
			// js.forEach((js_file) => {
			// 	let appConnectionScript = document.createElement('script');
			// 	appConnectionScript.setAttribute('src',this.$store.state.dir+js_file);
			// 	document.head.appendChild(appConnectionScript);
			// });
		}
	}
};
</script>

<style scoped>

/* .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
} */

</style>

